import { Skeleton } from "@/components/ui/skeleton";
import { Card } from "@/components/ui/card";

const GameListSkeleton = () => {
  return (
    <div className="space-y-3">
      {Array(2).fill(0).map((_, i) => (
        <Card key={i} className="rounded-xl p-4">
          <Skeleton className="h-5 w-48" />
          <Skeleton className="h-4 w-32 mt-1" />
          <Skeleton className="h-4 w-56 mt-3" />
        </Card>
      ))}
    </div>
  );
};

export default GameListSkeleton;
